import React from 'react'
import { UseFormSetValue } from 'react-hook-form'

import { Rule } from 'types/rules'

type FormValues = {
	reorderedRules: string[]
	fallbackTemplateId: string
}

type UseRuleReorderingProps = {
	rules: Rule[]
	setValue: UseFormSetValue<FormValues>
}

export function useRuleReordering({ rules, setValue }: UseRuleReorderingProps) {
	const [fieldsOrder, setFieldsOrder] = React.useState<string[]>([])

	React.useEffect(() => {
		const ruleIds = rules.map((rule) => rule.id)
		setFieldsOrder(ruleIds)
		setValue('reorderedRules', ruleIds, { shouldDirty: false })
	}, [rules, setValue])

	const handleReorder = React.useCallback(
		(newOrder: string[]) => {
			setFieldsOrder(newOrder)
			setValue('reorderedRules', newOrder, { shouldDirty: true })
		},
		[setValue],
	)

	const handleDragEnd = React.useCallback(
		(ruleId: string) => {
			const initIndex = rules.findIndex((rule) => rule.id === ruleId)
			const destinationIndex = fieldsOrder.findIndex((id) => id === ruleId)

			if (initIndex === destinationIndex || initIndex === -1) {
				return
			}

			handleReorder(fieldsOrder)
		},
		[rules, fieldsOrder, handleReorder],
	)

	return {
		fieldsOrder,
		setFieldsOrder: handleReorder,
		handleDragEnd,
	}
}
